var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnNftsensei = function SvgIcnNftsensei(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.515 9.375 2.86 2.99-1.744 1.823-4.604-4.813 4.604-4.813 1.744 1.823-2.86 2.99Z",
    stroke: "#EE2626",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12.236 9.377-2.86 2.99-2.86-2.99 2.86-2.99 2.86 2.99Z",
    stroke: "#EE2626",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m15.723 9.375-4.604 4.813-1.744-1.823 2.86-2.99-2.86-2.99 1.744-1.822 4.604 4.812Z",
    stroke: "#EE2626",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m9.452 6.662-2.67 2.791 2.512 2.626 2.67-2.791-2.512-2.626Z",
    fill: "#EE2626"
  })));
};
export default SvgIcnNftsensei;